import styled from 'styled-components';
import {Flexbox} from '@/styled-components';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles/palette';

export const ButtonItem = styled(Flexbox).withConfig({
  shouldForwardProp: interceptProps(['active', 'disabled']),
})<{
  active?: boolean;
  disabled?: boolean;
}>`
  padding: 8px 12px 8px 8px;
  font-weight: 700;
  min-height: 42px;
  color: ${palette.textPrimary};
  background-color: ${palette.white};
  border: solid 1px ${palette.gray300};
  ${({disabled}) =>
    disabled
      ? `
      color: ${palette.disabled};`
      : `
      cursor: pointer;
      &:hover {
        background-color: ${palette.gray100};
      }
  `}
  ${({active}) =>
    active &&
    `
      background-color: ${palette.gray100};
      border-color: ${palette.teal200} !important;
      color: ${palette.teal200};
    `}
`;

export const ButtonContainer = styled.div`
  position: relative;
  &:first-of-type {
    ${ButtonItem} {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  }

  &:last-of-type {
    ${ButtonItem} {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  &:not(:first-of-type) {
    ${ButtonItem} {
      border-left-color: transparent;
    }
  }
`;
